import { Text } from "@chakra-ui/react";
import { NewPageLink } from "../Common/NewPageLink";
import Font, { FontDecoration, Spacing } from "../Utils/Calligraphy";

export const SectionDependenciesUrlsBox = () => {
  return (
    <>
      <Text
        fontFamily={Font.MediumItalic}
        decoration={FontDecoration.Underline}
        textAlign={Spacing.TextAlignCenter}
      >
        <NewPageLink
          href={"https://github.com/facebook/react"}
          text={"react"}
        />{" "}
        | License:{" "}
        <NewPageLink
          href={"https://github.com/facebook/react?tab=MIT-1-ov-file#readme"}
          text={"MIT"}
        />
      </Text>
      <Text
        fontFamily={Font.MediumItalic}
        decoration={FontDecoration.Underline}
        textAlign={Spacing.TextAlignCenter}
      >
        <NewPageLink
          href={"https://github.com/chakra-ui/chakra-ui"}
          text={"@chakra-ui/react"}
        />{" "}
        | License:{" "}
        <NewPageLink
          href={
            "https://github.com/chakra-ui/chakra-ui?tab=MIT-1-ov-file#readme"
          }
          text={"MIT"}
        />
      </Text>
      <Text
        fontFamily={Font.MediumItalic}
        decoration={FontDecoration.Underline}
        textAlign={Spacing.TextAlignCenter}
      >
        <NewPageLink
          href={"https://github.com/emotion-js/emotion"}
          text={"@emotion/react"}
        />{" "}
        | License:{" "}
        <NewPageLink
          href={
            "https://github.com/emotion-js/emotion?tab=MIT-1-ov-file#readme"
          }
          text={"MIT"}
        />
      </Text>
      <Text
        fontFamily={Font.MediumItalic}
        decoration={FontDecoration.Underline}
        textAlign={Spacing.TextAlignCenter}
      >
        <NewPageLink
          href={"https://github.com/firebase/firebase-js-sdk"}
          text={"firebase"}
        />{" "}
        | License:{" "}
        <NewPageLink
          href={
            "https://github.com/firebase/firebase-js-sdk?tab=License-1-ov-file#readme"
          }
          text={"Apache-2.0, BSD-3-Clause"}
        />
      </Text>
      <Text
        fontFamily={Font.MediumItalic}
        decoration={FontDecoration.Underline}
        textAlign={Spacing.TextAlignCenter}
      >
        <NewPageLink
          href={"https://github.com/framer/motion"}
          text={"framer-motion"}
        />{" "}
        | License:{" "}
        <NewPageLink
          href={"https://github.com/framer/motion?tab=MIT-1-ov-file#readme"}
          text={"MIT"}
        />
      </Text>
      <Text
        fontFamily={Font.MediumItalic}
        decoration={FontDecoration.Underline}
        textAlign={Spacing.TextAlignCenter}
      >
        <NewPageLink
          href={
            "https://github.com/react-icons/react-icons/blob/master/packages/react-icons/src/icons/index.ts"
          }
          text={"react-icons/fa6 (Font Awesome 6)"}
        />{" "}
        | License:{" "}
        <NewPageLink
          href={"https://creativecommons.org/licenses/by/4.0/"}
          text={"CC BY 4.0"}
        />
      </Text>
      <Text
        fontFamily={Font.MediumItalic}
        decoration={FontDecoration.Underline}
        textAlign={Spacing.TextAlignCenter}
      >
        <NewPageLink
          href={
            "https://github.com/react-icons/react-icons/blob/master/packages/react-icons/src/icons/index.ts"
          }
          text={"react-icons/bs (Bootstrap Icons)"}
        />{" "}
        | License:{" "}
        <NewPageLink
          href={"https://opensource.org/licenses/MIT"}
          text={"MIT"}
        />
      </Text>
      <Text
        fontFamily={Font.MediumItalic}
        decoration={FontDecoration.Underline}
        textAlign={Spacing.TextAlignCenter}
      >
        <NewPageLink
          href={"https://github.com/remix-run/react-router"}
          text={"react-router-dom"}
        />{" "}
        | License:{" "}
        <NewPageLink
          href={
            "https://github.com/remix-run/react-router?tab=MIT-1-ov-file#readme"
          }
          text={"MIT"}
        />
      </Text>
      <Text
        fontFamily={Font.MediumItalic}
        decoration={FontDecoration.Underline}
        textAlign={Spacing.TextAlignCenter}
      >
        <NewPageLink
          href={"https://github.com/facebook/create-react-app"}
          text={"react-scripts"}
        />{" "}
        | License:{" "}
        <NewPageLink
          href={
            "https://github.com/facebook/create-react-app?tab=MIT-1-ov-file#readme"
          }
          text={"MIT"}
        />
      </Text>
      <Text
        fontFamily={Font.MediumItalic}
        decoration={FontDecoration.Underline}
        textAlign={Spacing.TextAlignCenter}
      >
        <NewPageLink
          href={"https://github.com/Microsoft/TypeScript"}
          text={"typescript"}
        />{" "}
        | License:{" "}
        <NewPageLink
          href={
            "https://github.com/Microsoft/TypeScript?tab=Apache-2.0-1-ov-file#readme"
          }
          text={"Apache-2.0"}
        />
      </Text>
      <Text
        fontFamily={Font.MediumItalic}
        decoration={FontDecoration.Underline}
        textAlign={Spacing.TextAlignCenter}
      >
        <NewPageLink
          href={"https://threejs.org/"}
          text={"three"}
        />{" "}
        | License:{" "}
        <NewPageLink
          href={
            "https://github.com/mrdoob/three.js?tab=MIT-1-ov-file#readme"
          }
          text={"MIT"}
        />
      </Text>
      <Text
        fontFamily={Font.MediumItalic}
        decoration={FontDecoration.Underline}
        textAlign={Spacing.TextAlignCenter}
      >
        <NewPageLink
          href={"https://github.com/pmndrs/react-three-fiber"}
          text={"@react-three/fiber"}
        />{" "}
        | License:{" "}
        <NewPageLink
          href={
            "https://github.com/pmndrs/react-three-fiber?tab=MIT-1-ov-file#readme"
          }
          text={"MIT"}
        />
      </Text>
    </>
  );
};
